const hideSticky = (id) => {
	const sticky = document.getElementById(id)
	sticky.classList.add('hidden')
}
const showSticky = (id) => {
	const sticky = document.getElementById(id)
	sticky.classList.remove('hidden')
}


// Sticky kurz vor dem Jobs Bereich ausblenden
window.addEventListener('scroll', () => {
	if (document.getElementById('sticky')) {
		const jobsContainer = document.querySelector('.mitarbeiter__grid .text__content').getBoundingClientRect()
		const jobsContainerOffset = jobsContainer.top
		const jobsContainerHeight = jobsContainer.height
		if (jobsContainerOffset - jobsContainerHeight < 0) {
			hideSticky('sticky')
		} else {
			if (document.getElementById('sticky').classList.contains('hidden')) {
				showSticky('sticky')
			}
		}
	}
})

// Nach Laden der Seite zum Hash scrollen (wenn alle DOM Elemente gerendert sind)
window.addEventListener('DOMContentLoaded', (e) => {
	if (location.hash.substr(1)) {
		const targetElement = document.getElementById(location.hash.substr(1))
		window.scrollTo({top: targetElement.getBoundingClientRect().top + window.scrollY, left: 0, behavior: 'smooth'})				
	}
})